import "@/App.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Sensors from "@/pages/Sensors";
import SensorDetail from "@/pages/SensorDetail";
import Settings from "@/pages/Settings";
import AdminOnboarding from "@/pages/AdminOnboarding";
import AdminMildewDiagnostics from "@/pages/AdminMildewDiagnostics";
import AdminDataExplorer from "@/pages/AdminDataExplorer";
import VineyardMap from "@/pages/VineyardMap";

function AdminRoute({ children }) {
  const { user } = useAuth();
  return user?.role === "platform_admin" ? children : <Navigate to="/" replace />;
}

function CustomerRoute({ children }) {
  const { user } = useAuth();
  return user?.role === "platform_admin" ? <Navigate to="/admin/onboarding" replace /> : children;
}

function HomeRoute() {
  const { user } = useAuth();
  return user?.role === "platform_admin" ? <Navigate to="/admin/onboarding" replace /> : <Overview />;
}

function AppShell() {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-page" data-testid="auth-loading">
        <Loader2 className="animate-spin text-brand" size={32} />
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<HomeRoute />} />
          <Route path="/sensores" element={<CustomerRoute><Sensors /></CustomerRoute>} />
          <Route path="/sensores/:id" element={<CustomerRoute><SensorDetail /></CustomerRoute>} />
          <Route path="/mapa" element={<CustomerRoute><VineyardMap /></CustomerRoute>} />
          <Route path="/ajustes" element={<CustomerRoute><Settings /></CustomerRoute>} />
          <Route path="/admin/onboarding" element={<AdminRoute><AdminOnboarding /></AdminRoute>} />
          <Route path="/admin/mildew" element={<AdminRoute><AdminMildewDiagnostics /></AdminRoute>} />
          <Route path="/admin/explorer" element={<AdminRoute><AdminDataExplorer /></AdminRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AppShell />
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
